import { useState } from 'react'
import { num } from './format'

/** An hours cell. Blurring saves; a value the week cannot hold snaps back.
 *  `locked`, unlike a plain `disabled` (which just means "you lack
 *  permission"), flags a cell that's blocked for a reason worth noticing --
 *  today, a staffing Scenario's own departed person (see StaffingMonthly.jsx's
 *  isFired) -- and renders it red instead of the ordinary neutral gray. */
export function HoursCell({ value, max, disabled, locked, onCommit }) {
  const [draft, setDraft] = useState(String(value ?? 0))
  // Adjust during render rather than in an effect: when the server sends a new
  // value the field has to follow it, and an effect would render the stale
  // number first and then correct it.
  const [seen, setSeen] = useState(value)
  if (value !== seen) {
    setSeen(value)
    setDraft(String(value ?? 0))
  }

  const commit = () => {
    const next = draft.trim() === '' ? 0 : Number(draft)
    // Out of range means the typist is wrong, not the plan: put the stored
    // value back rather than sending something the server will refuse.
    if (!Number.isFinite(next) || next < 0 || next > max) {
      setDraft(String(value ?? 0))
      return
    }
    if (next !== value) onCommit(next)
  }

  if (disabled) {
    return (
      <span className={`tabular-nums ${locked ? 'text-red-700 font-semibold bg-red-50 px-1 rounded' : 'text-gray-700'}`}>
        {value ? num(value) : (locked ? '0' : '')}
      </span>
    )
  }
  return (
    <input
      value={draft}
      onChange={e => setDraft(e.target.value)}
      onBlur={commit}
      onKeyDown={e => {
        if (e.key === 'Enter') e.currentTarget.blur()
        if (e.key === 'Escape') setDraft(String(value ?? 0))
      }}
      className={`w-full bg-transparent text-center tabular-nums text-xs rounded
        border border-transparent hover:border-gray-200 focus:border-gray-400
        focus:bg-white focus:outline-none px-0.5 py-0.5
        ${value ? 'text-gray-900' : 'text-gray-300'}`}
    />
  )
}
